import { create } from 'zustand';

export interface PushEventPayload {
  eventId: number;
  imageUrl: string;
  eventTime: string;
}

interface PushStore {
  pending: PushEventPayload | null;
  set: (e: PushEventPayload | null) => void;
}

export const usePushStore = create<PushStore>((set) => ({
  pending: null,
  set: (e) => set({ pending: e }),
}));